// Configuração do tema personalizado para o Ant Design
const theme = {
  token: {
    colorPrimary: '#37D67A', // Verde da logo Acelera Venda
    colorPrimaryHover: '#2EBE6A', // Uma variação um pouco mais escura para hover
    colorPrimaryActive: '#28A85F', // Uma variação mais escura para estado ativo
    colorPrimaryText: '#FFFFFF', // Cor do texto em botões primários
  },
};

export default theme; 